import React, { memo } from 'react';
import Icon from 'react-native-vector-icons/Ionicons';
import { COMMUNITY_RESOURCE_ICONS } from '@/assets/admin/CommunityResourceIcons';
import { getCommunityResourceIcon } from '@/constants/residents/communityResourceIcons';

interface ResourceIconProps {
  iconKey?: string;
  size?: number;
  color?: string;
}

const ResourceIconBase: React.FC<ResourceIconProps> = ({ iconKey, size = 18, color = '#9CA3AF' }) => {
  const key = iconKey as keyof typeof COMMUNITY_RESOURCE_ICONS | undefined;
  const SvgIcon = key ? COMMUNITY_RESOURCE_ICONS[key] : undefined;

  if (SvgIcon) {
    return <SvgIcon width={size} height={size} color={color} />;
  }

  return <Icon name={getCommunityResourceIcon(iconKey)} size={size} color={color} />;
};

ResourceIconBase.displayName = 'ResourceIcon';

export const ResourceIcon = memo(ResourceIconBase);


